import { useAuth } from '@/lib/auth';

import { 
    Button,
    TextInput,
    Stack,
    PasswordInput,
    Box,
    LoadingOverlay
} from '@mantine/core';

import { useForm } from '@mantine/form';
import { zod4Resolver as zodResolver } from 'mantine-form-zod-resolver';

import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { 
    IconArrowNarrowRight
} from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';
import { ERROR_CODES } from '@/types/error_codes';
import { ErrorAlert } from '@/components/Error/ErrorAlert';
import { useState } from 'react';

type LoginFormProps = {
    onSuccess: () => void;
}

const loginInitValues = {
    username: '',
    password: ''
}

const schema = z.object({
    username: z.string()
        .min(1, "username is too short"),
    password: z.string()
        .min(1, "password is too short")
})

export const LoginForm = ({ onSuccess }: LoginFormProps) => {
    const { t } = useTranslation();
    const { login } = useAuth();
    const [visible, { toggle }] = useDisclosure(false);
    const [isError, setIsError] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>('')
    // TODO: S'assurer que l'overlay fonctionne bien quand on se connecte

    async function handleSubmit(e: React.SyntheticEvent) {
        e.preventDefault();

        form.validate();
        form.onSubmit(
            (values: any) => console.log(values),
            (errors: any) => console.error(errors)
        );
        const target = e.target as typeof e.target & {
            username: { value: string };
            password: { value: string };
        };
        const data = {
            username: target.username.value,
            password: target.password.value,
            userEnteredCode: "",
        };
        JSON.stringify(data, null, 2)

        await login(data)
            .then(() => {
                onSuccess();
            })
            .catch((err: any) => {
                if (err.response.data.studiocast.code === ERROR_CODES.USER_INVALID_AUTHENTIFICATION ||
                    err.response.data.studiocast.code === ERROR_CODES.USER_DOES_NOT_EXIST)
                    setErrorMessage(t('error.authentificationInvalid'))
                else 
                    setErrorMessage(t('error.error'))
                setIsError(true)
            })
    }

    const form = useForm({
        initialValues: loginInitValues,
        validate: zodResolver(schema)
    })

    return (
        <>
            <Box maw={400} pos="relative">
                <LoadingOverlay visible={visible} overlayBlur={2} />
            </Box>
            <form id="login-form" onSubmit={handleSubmit}>
                <Stack>
                    <ErrorAlert displayed={isError} title={t('misc.error')} text={errorMessage} />
                    <TextInput
                        radius="md"
                        autoComplete='username'
                        name="username"
                        label={t('user.username')}
                        {...form.getInputProps('username')}/>
                    <PasswordInput
                        radius="md"
                        autoComplete='current-password'
                        name="password"
                        label={t('user.password')}
                        {...form.getInputProps('password')}/>
                    <Button
                        radius="md"
                        rightIcon={<IconArrowNarrowRight />} 
                        onClick={toggle} 
                        type='submit' 
                        form="login-form">
                        {t('action.continue')}
                    </Button>
                </Stack>
            </form>
        </>
    );
};